module.exports = __webpack_public_path__ + "img/qr-code.a2cdba49.png";